import { BrowserType, DeviceDetector } from '../services/device-detector.service';
import { ClientStartupConfigService } from '../shared-context/client-startup-config.service';
import { BrowserIdleCallbackService } from './browser-idle-callback.service';
import { IdleCallbackService } from './idle-callback.service';
import { ShimIdleCallbackService } from './shim-idle-callback.service';

export function idleCallbackServiceFactory(
    clientStartupConfigService: ClientStartupConfigService,
    deviceDetector: DeviceDetector
): IdleCallbackService {
    // Provide a function that will obtain the service worker user ID lazily.
    // This is to ensure that getting the ID doesn't run during app startup

    // Safari does not support RequestIdleCallback natively.
    // Use ShimIdleCallbackService instead of rIC polyfill.
    return clientStartupConfigService.config.automatedTestRunning ||
        deviceDetector.deviceInfo.browser.browserType === BrowserType.Safari
     ? new ShimIdleCallbackService() : new BrowserIdleCallbackService();
}
